import { render, staticRenderFns } from "./roads-who-responsible.vue?vue&type=template&id=0744e3a2"
import script from "./roads-who-responsible.vue?vue&type=script&lang=js"
export * from "./roads-who-responsible.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports